export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13850.f37790f7.jpg";